<div class="content_main-container" *ngrxLet="userProfile$ as userProfile">
  @if (!!userProfile?.isLoading) {
  <div class="content_main-container-loader">
    <ngx-skeleton-loader count="5" appearance="circle"></ngx-skeleton-loader>
    <span> {{ 'USER_PORTAL.UPDATING.USER_PROFILE' | translate }}</span>
  </div>
  } @else {
  <div class="flex-row space-between" id="link-bank_container">
    @if (refreshTokenExpired) {
    <pbb-notice id="payment-method-error-message" [type]="noticeType.ERROR"
      [title]="'COMMON.PAYMENT.ERROR' | translate"
      ></pbb-notice>
    }
    <h1 id="link-bank_title">{{ 'COMMON.BUTTON.LINK_ANOTHER_BANK' | translate }}</h1>
    <button
      id="link-bank_button"
      (click)="openLinkBankSheet($event)"
      [attr.aria-label]="'COMMON.BUTTON.LINK_ANOTHER_BANK_ADD' | translate"
      class="link-bank-add-button"
    >
      <pbb-svg-icon
        [icon]="'add-btn'"
        [title]="'COMMON.BUTTON.LINK_ANOTHER_BANK_ADD' | translate"
        class="icon-md"
        aria-hidden="true"
      ></pbb-svg-icon>
    </button>
  </div>
  <div class="flex-row mt-24"></div>
  <pbb-payment-method-list
    id="manage-payment-methods-list"
    [userProfile]="userProfile?.data"
    [(ngModel)]="selectedAccount"
    [defaultSelectedAccount]="defaultSelectedAccount"
    [isCheckout]="isCheckout"
    (menuAction)="setMenuAction($event)"
    (continue)="onContinue()"
  ></pbb-payment-method-list>
  }
</div>
